module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAPFBMVEUAAADM1t3M1t3M1t3M1t2RweZVrO6Zpq5mdX8pLzMpLzMpLzMpLzMpLzMpLzMpLzOzwMmZqrW4wchcY2j00eVnAAAAEHRSTlMAUN//AP////9gv/8AIM/vJR7RlAAAAQlJREFUeAHt1t1uwyAMhmES1h/8AWng/u91rMoUZ6YTzpB6MJ6zcvBKIeDUHEyzbTZPH5zhPyarMr0MzVZlfhmySr+GLlfhcip0regaut0PbqdD9x+6hd7/aNII9d/scY5GaJwjR3jSbjaeyPnCeB8iNtrPETYxfIXCAh7SwLcllFDE30OI3jjUQ491fVimtoadM4Rdsru1sJxcS9iRAZN1oQzGgMupPZQyZKhiLVrW/luow2Z3eP3dDmS3K9Lt0vYbI3ywKcjBVjjSh+So3ZwN+WKERmiERmiEmkPJqqRqiABkq5IBkAg59ieiScoonAj5iBOil6GwQG0JIlSECKUYPAsxjqBAzjOfb5F+fzWCvcoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/devfest/1f4c7.png
// module id = 1022
// module chunks = 0